// extracted by mini-css-extract-plugin
export default {"textInput":"newProduct_textInput__8uiLP","imgWrap":"newProduct_imgWrap__TdUy9","img":"newProduct_img__wegMz","wrap":"newProduct_wrap__biQMI"};